/*
 * Copyright (c) 2020.
 * This file is part of the Compo B2B application.
 * (c) Compo soft - Vladimir Ganturin <gun2rin@gmail.com>
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */

import {ChangeDetectionStrategy, Component, OnInit} from '@angular/core';
import {DocumentMenu} from 'compob2b-libs';
import {translations} from '../../../../../environments/translations.ru';
import {CreateUpdateComponent} from '../../../../admin-shared/crud-components/create-update/create-update.component';
import {CrudConfig} from '../../../../admin-shared/interfaces/crud.config';
import {DAM_PERSON_FORM} from '../dam-person-forms.config';

@Component({
  selector: 'app-create-update-dam-person',
  templateUrl: '../../../../admin-shared/crud-components/create-update/create-update.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CreateUpdateDamPersonComponent extends CreateUpdateComponent<DocumentMenu> implements OnInit {

  title = translations.person;
  protected uri = '/dam-person';
  absolutePath = '/cabinet/dam/dam-person';

  config: CrudConfig = {
    uri: this.uri,
    columns: DAM_PERSON_FORM,
    title: this.title,
    absolutePath: this.absolutePath
  };

  ngOnInit() {
    super.setConfig(this.config);
    super.ngOnInit();
  }

}
